import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { CustomLoader } from '../../../../../components/custom-loader';

export const CustomUidFormView = ({ isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<>
			<div className="custom-uid-form">
				<div className="custom-uid-form__wrapper">
					<Grid className="custom-uid-form">
						<Grid.Row className="custom-uid-form__content-row">
							<Grid.Column width={6} className="custom-uid-form__content-column">
								Номер заявки
							</Grid.Column>
							<Grid.Column width={7} className="custom-uid-form__content-column">
								<div className="custom-uid-form__content-column-field">
									<Field
										name="custom_uid"
										type="text"
										component={FormInputField}
										autoComplete="off"
										placeholder="Укажите номер заявки"
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</div>
			</div>
		</>
	);
};

CustomUidFormView.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};
